export default {
      id: "txt_bullet-list-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_bullet-list",
      toString: function () {
        return this.url;
      }
    }